module.exports = __webpack_public_path__ + "images/background/image_thumbnail/5-on-f1840d5fc2d54d59c66722b331237ecb.jpg";